<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/litenghui/production/report/order/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchanhuibaodanhao')">
            <el-input v-model="yt.conditions.no" placeholder="请输入生产汇报单号"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo" placeholder="请输入生产工单号"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo" placeholder="请输入ERP工单号"></el-input>
          </el-form-item>
          <el-form-item :label="$t('biaoqiantiaomahao')">
            <el-input v-model="yt.conditions.labelCode" placeholder="请输入标准条码号"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shenhezhuangtai')">
            <yi_dictionary_select :ids.sync="yt.conditions.status" type="RUIKE_PENDING_RECEIPT_REVIEW_STATUS" clearable></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear(conditions)">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #caozuo="scope">
        <el-button
          type="text"
          :disabled="scope.row.status === 2"
          @click="
            yt.editObj = scope.row;
            yt.req('POST', '/custom/litenghui/production/report/order/audit');
          "
          >{{ $t('shenhe') }}</el-button
        >
        <el-button type="text" @click="yt.showEditDialog(scope.row.no, scope.row, '1300px')" v-if="utils.checkPower('web_production_management_production_report_details_lth')">{{ $t('mingxi') }}</el-button>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <div class="dialog-scroller">
        <report-details :data="yt.editObj" v-if="yt.isShowEditDialog" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ReportDetails from './report_details/index.vue';

export default {
  name: 'web_production_report_lth',
  components: {
    ReportDetails
  },
  data() {
    return {
      columns: [
        {
          label: 'shengchanhuibaodanhao',
          prop: 'no'
        },
        {
          label: 'shenhezhuangtai',
          prop: 'status',
          type: 'dictionary',
          key: 'RUIKE_PENDING_RECEIPT_REVIEW_STATUS'
        },
        {
          label: 'shenheren',
          prop: 'reviewedByObject.nickname'
        },
        {
          label: 'shenheshijian',
          type: 'time',
          prop: 'reviewedTime'
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          type: 'time',
          prop: 'createTime'
        },
        {
          label: 'caozuo',
          type: 'slot'
        }
      ],
      showDetailsModal: false,
      selectedRow: null
    };
  },
  methods: {
    beforeAdd(params, url) {
      return params;
    },
    showDetails(row) {
      this.selectedRow = row;
      this.showDetailsModal = true;
    }
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  }
};
</script>

<style lang="scss" scoped></style>
